interface ScreenOverride extends Screen {
  availLeft?: number;
  availTop?: number;
}

type CreatePopupProps = {
  url: string,
  name?: string,
  width?: number,
  height?: number,
};

export const createPopup = ({
  url,
  name = '',
  width = 500,
  height = 800,
}: CreatePopupProps) => {
  if (typeof window === 'undefined') return null;

  const correctionLeft = (window.screen as ScreenOverride).availLeft ?? 0;
  const correctionTop = (window.screen as ScreenOverride).availTop ?? 0;

  const left = (window.screen.width - width) / 2 + correctionLeft;
  const top = (window.screen.height - height) / 2 + correctionTop;

  return window.open(
    url,
    name,
    `width=${width},height=${height},left=${left},top=${top}`,
  );
};
